export default "__VITE_ASSET__61b79979__"